var alignment_rtlignore_default = {
  "alignLeft": "_1k5ja",
  "textWrapNowrap": "C14iL",
  "alignRight": "xnBNQ",
  "alignCenter": "QihIG",
  "sizeFullWidth": "lYVIr",
  "renderedInTable": "_4-XWN",
  "sizeOriginal": "uS15c",
  "sizeContent": "VpGHz",
  "sizeSmall": "_8TR-I",
  "sizeSmallCenter": "cm5DW",
  "flex": "v5dcv",
  "LEFT": "ECGSH",
  "CENTER": "MjsR-",
  "RIGHT": "bZ5fx",
  "AUTO": "sOJ02",
  "JUSTIFY": "gGp-Y"
};
export {
  alignment_rtlignore_default as default
};
//# sourceMappingURL=alignment.rtlignore-scss.js.map
